import { render, staticRenderFns } from "./WalletCardHeadlineSelect.vue?vue&type=template&id=fe5fa4de&"
import script from "./WalletCardHeadlineSelect.vue?vue&type=script&lang=js&"
export * from "./WalletCardHeadlineSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports